import { Kbd, KbdGroup } from "@/components/ui/kbd"
import { isMac } from "@/lib/platform"
import { cn } from "@/lib/utils"

const SYMBOLS: Record<string, string> = {
  mod: isMac ? "⌘" : "Ctrl",
  shift: isMac ? "⇧" : "Shift",
  alt: isMac ? "⌥" : "Alt",
  ctrl: isMac ? "⌃" : "Ctrl",
  enter: "↵",
  esc: "Esc",
  up: "↑",
  down: "↓",
  left: "←",
  right: "→",
}

/**
 * Keyboard shortcut hint. `keys={["mod", "k"]}` renders ⌘K on macOS and Ctrl K elsewhere.
 * Use `then` for sequences: `keys={["g", "s"]} sequence` renders "G then S".
 */
export function Shortcut({
  keys,
  sequence = false,
  className,
}: {
  keys: string[]
  sequence?: boolean
  className?: string
}) {
  return (
    <KbdGroup className={cn("font-mono", className)}>
      {keys.map((k, i) => (
        <Kbd key={`${k}-${i}`} className="font-sans">
          {SYMBOLS[k.toLowerCase()] ?? (k.length === 1 ? k.toUpperCase() : k)}
        </Kbd>
      ))}
      {sequence && <span className="sr-only">{keys.join(" then ")}</span>}
    </KbdGroup>
  )
}

export { Kbd }
